module.exports = __webpack_public_path__ + "img/1@2x.7db8aac.jpg";